import { all, call, put, takeLatest } from 'redux-saga/effects';
import { GET_COMBO_CHDT } from 'actions/CuaHangDoiTac/actionTypes';
import {
  getComboCHDTSuccess,
  getComboCHDTFailure,
} from 'actions/CuaHangDoiTac';
import CuaHangDoiTacApi from 'service/cuaHangDoiTacApi';
import { pushNotification } from 'utils/notifications';

function* getComboCHDT(action) {
  try {
    const response = yield call(CuaHangDoiTacApi.combo, action.dataSearch);
    if (response.ok) {
      yield put(getComboCHDTSuccess(response.data));
    } else {
      pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
      yield put(getComboCHDTFailure());
    }
  } catch (error) {
    pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
    yield put(getComboCHDTFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_COMBO_CHDT, getComboCHDT);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
